import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  adMedia: {
    height: ({ height }) => height,
    // crop the image or video to 4:5 ratio
    // maxHeight for single image or video ad is 300 because width is 240, 4:5 = 240:300
    maxHeight: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      width: '100%'
    },

    videoPreviewContainer: {
      width: '100%'
    },
    '& video': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  }
})

export default useStyles
